const __WEBPACK_NAMESPACE_OBJECT__ = ol.TileState;